import { Box, ToggleButton, ToggleButtonProps, Tooltip, Typography } from '@mui/material';
import { ElementType } from 'react';

interface StatusFilterToggleButtonProps extends Pick<ToggleButtonProps, 'value' | 'color' | 'sx'> {
  icon: ElementType;
  label: string;
  count: number;
}

/**
 * Toggle button with an icon and a parenthesized count for status screen filter groups.
 */
export function StatusFilterToggleButton({
  value,
  icon: Icon,
  label,
  count,
  color,
  sx,
}: StatusFilterToggleButtonProps) {
  const accessibleLabel = `${label} (${count})`;

  return (
    <ToggleButton value={value} aria-label={accessibleLabel} color={color} sx={sx}>
      <Tooltip title={accessibleLabel} placement="bottom">
        <Box display="flex" alignItems="center" gap={0.5}>
          <Icon fontSize="small" />
          <Typography variant="caption" component="span" color="text.secondary">
            ({count})
          </Typography>
        </Box>
      </Tooltip>
    </ToggleButton>
  );
}
